import * as React from 'react';
const SvgNode = (props) => (
  <svg viewBox="0 0 145 88" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M71.713 88c-.491 0-.95-.13-1.376-.357l-4.36-2.566c-.655-.358-.327-.488-.13-.553.884-.292 1.048-.357 1.966-.877.098-.065.23-.032.328.033l3.343 1.981c.131.065.295.065.393 0l13.078-7.504c.13-.065.197-.195.197-.357V62.825c0-.163-.066-.292-.197-.358l-13.078-7.47c-.13-.066-.295-.066-.393 0l-13.078 7.47c-.13.065-.196.228-.196.358V77.8c0 .13.065.292.196.357l3.573 2.047c1.934.974 3.147-.163 3.147-1.3v-14.78c0-.195.163-.39.393-.39h1.671c.197 0 .394.163.394.39v14.78c0 2.567-1.41 4.061-3.868 4.061-.754 0-1.344 0-3.015-.812l-3.442-1.95a2.737 2.737 0 0 1-1.376-2.37V62.856c0-.974.524-1.884 1.376-2.371l13.078-7.504c.82-.455 1.934-.455 2.753 0l13.077 7.504a2.737 2.737 0 0 1 1.377 2.371v14.975c0 .975-.525 1.885-1.377 2.372L73.09 87.708a3.38 3.38 0 0 1-1.377.292Zm4.032-10.297c-5.736 0-6.916-2.6-6.916-4.808 0-.195.164-.39.393-.39h1.705c.196 0 .36.13.36.325.263 1.722 1.016 2.566 4.49 2.566 2.754 0 3.934-.617 3.934-2.079 0-.844-.328-1.461-4.622-1.884-3.572-.357-5.801-1.137-5.801-3.963 0-2.631 2.229-4.19 5.965-4.19 4.195 0 6.26 1.429 6.523 4.547a.522.522 0 0 1-.099.293c-.066.065-.164.13-.262.13h-1.704a.383.383 0 0 1-.36-.293c-.394-1.786-1.41-2.371-4.098-2.371-3.015 0-3.376 1.04-3.376 1.819 0 .942.426 1.234 4.49 1.754 4.032.52 5.933 1.267 5.933 4.06-.033 2.86-2.393 4.484-6.555 4.484Z"
      fill="#539E43"
    />
    <path
      d="M31.137 29.431a1.65 1.65 0 0 0-.852-1.43l-13.897-7.925a2.03 2.03 0 0 0-.754-.228h-.131c-.262 0-.524.097-.754.228L.852 28A1.65 1.65 0 0 0 0 29.431l.033 21.31c0 .292.164.584.426.714.262.163.59.163.82 0l8.259-4.677a1.65 1.65 0 0 0 .852-1.43v-9.972c0-.585.328-1.137.852-1.43l3.507-2.014a1.6 1.6 0 0 1 .852-.227c.295 0 .59.065.82.227l3.507 2.014c.524.293.852.845.852 1.43v9.972c0 .585.328 1.137.852 1.43l8.26 4.677c.262.163.59.163.852 0a.806.806 0 0 0 .426-.714l-.033-21.31ZM97.934.098c-.262-.13-.59-.13-.82 0-.262.162-.426.422-.426.714v21.115c0 .195-.098.39-.294.52a.633.633 0 0 1-.59 0l-3.475-1.982a1.702 1.702 0 0 0-1.671 0L76.76 28.424a1.65 1.65 0 0 0-.852 1.43v15.884c0 .584.327 1.137.852 1.43l13.897 7.958a1.701 1.701 0 0 0 1.671 0l13.897-7.959a1.65 1.65 0 0 0 .852-1.43V6.14c0-.618-.327-1.17-.852-1.462L97.934.098Zm-1.278 40.41c0 .162-.066.292-.197.357l-4.752 2.729a.49.49 0 0 1-.427 0l-4.752-2.729c-.131-.065-.197-.227-.197-.357v-5.457c0-.163.066-.293.197-.358l4.752-2.728a.49.49 0 0 1 .427 0l4.752 2.728c.131.065.197.228.197.358v5.457Zm47.524-5.587c.525-.292.82-.845.82-1.43v-3.865c0-.585-.328-1.137-.82-1.43l-13.798-7.926a1.703 1.703 0 0 0-1.672 0l-13.896 7.959a1.65 1.65 0 0 0-.853 1.43v15.884c0 .585.328 1.137.853 1.43l13.798 7.796a1.641 1.641 0 0 0 1.639 0l8.358-4.613a.807.807 0 0 0 .426-.715.807.807 0 0 0-.426-.714l-13.963-7.959c-.262-.162-.426-.422-.426-.714v-4.97c0-.293.164-.585.426-.715l4.359-2.47a.809.809 0 0 1 .853 0l4.359 2.47c.262.162.426.422.426.715v3.898c0 .292.164.584.426.714.262.163.59.163.852 0l8.259-4.775Z"
      fill="#333"
    />
    <path
      d="M129.333 34.174a.301.301 0 0 1 .328 0l2.655 1.526a.34.34 0 0 1 .164.293v3.053c0 .13-.066.228-.164.293l-2.655 1.526a.302.302 0 0 1-.328 0l-2.655-1.526a.341.341 0 0 1-.164-.293v-3.053a.34.34 0 0 1 .164-.293l2.655-1.526Z"
      fill="#539E43"
    />
    <path
      d="M54.703 20.335a1.701 1.701 0 0 0-1.672 0L39.233 28.23a1.62 1.62 0 0 0-.82 1.429v15.82c0 .584.328 1.137.82 1.43L53.032 54.8a1.7 1.7 0 0 0 1.67 0l13.8-7.894a1.62 1.62 0 0 0 .82-1.43V29.659a1.69 1.69 0 0 0-.82-1.43l-13.8-7.893Z"
      fill="url(#node_svg__a)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m52.252 17.444-.197.098h.262l-.065-.098Z"
      fill="url(#node_svg__b)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.246 46.907c.394-.227.689-.617.82-1.039L53.857 20.14c-.393-.065-.82-.032-1.18.195l-13.765 7.861 14.847 26.832c.216-.035.426-.1.623-.194l13.864-7.927Z"
      fill="url(#node_svg__c)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m69.525 46.648-.099-.163v.228l.099-.065Z"
      fill="url(#node_svg__d)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m68.246 46.907-13.831 7.894a1.99 1.99 0 0 1-.623.195l.262.487 15.34-8.803v-.195l-.394-.65c-.066.455-.36.845-.754 1.072Z"
      fill="url(#node_svg__e)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m68.246 46.907-13.831 7.894a1.99 1.99 0 0 1-.623.195l.262.487 15.34-8.803v-.195l-.394-.65c-.066.455-.36.845-.754 1.072Z"
      fill="url(#node_svg__f)"
    />
    <defs>
      <linearGradient
        id="node_svg__a"
        x1={9887.26}
        y1={1538.86}
        x2={7350.45}
        y2={9022.53}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#41873F" />
        <stop offset={0.329} stopColor="#418B3D" />
        <stop offset={0.635} stopColor="#419637" />
        <stop offset={0.932} stopColor="#3FA92D" />
        <stop offset={1} stopColor="#3FAE2A" />
      </linearGradient>
      <linearGradient
        id="node_svg__b"
        x1={-639997}
        y1={1181.83}
        x2={772550}
        y2={1181.83}
        gradientUnits="userSpaceOnUse">
        <stop offset={0.092} stopColor="#6CC04A" />
        <stop offset={0.286} stopColor="#66B848" />
        <stop offset={0.597} stopColor="#54A044" />
        <stop offset={0.862} stopColor="#41873F" />
      </linearGradient>
      <linearGradient
        id="node_svg__c"
        x1={-636.405}
        y1={4399.74}
        x2={14717.4}
        y2={4399.74}
        gradientUnits="userSpaceOnUse">
        <stop offset={0.092} stopColor="#6CC04A" />
        <stop offset={0.286} stopColor="#66B848" />
        <stop offset={0.597} stopColor="#54A044" />
        <stop offset={0.862} stopColor="#41873F" />
      </linearGradient>
      <linearGradient
        id="node_svg__d"
        x1={-1408500}
        y1={3186.48}
        x2={4049.83}
        y2={3186.48}
        gradientUnits="userSpaceOnUse">
        <stop offset={0.092} stopColor="#6CC04A" />
        <stop offset={0.286} stopColor="#66B848" />
        <stop offset={0.597} stopColor="#54A044" />
        <stop offset={0.862} stopColor="#41873F" />
      </linearGradient>
      <linearGradient
        id="node_svg__e"
        x1={-15059.8}
        y1={4424.2}
        x2={14615.6}
        y2={4424.2}
        gradientUnits="userSpaceOnUse">
        <stop offset={0.092} stopColor="#6CC04A" />
        <stop offset={0.286} stopColor="#66B848" />
        <stop offset={0.597} stopColor="#54A044" />
        <stop offset={0.862} stopColor="#41873F" />
      </linearGradient>
      <linearGradient
        id="node_svg__f"
        x1={2091.52}
        y1={-1990.53}
        x2={1296.45}
        y2={2212.97}
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#41873F" />
        <stop offset={0.329} stopColor="#418B3D" />
        <stop offset={0.635} stopColor="#419637" />
        <stop offset={0.932} stopColor="#3FA92D" />
        <stop offset={1} stopColor="#3FAE2A" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgNode;
